import { Component, OnInit } from '@angular/core';
import { LoginService } from "./login.service";
import { Router } from "@angular/router";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [
    LoginService,
  ]
})
export class LoginComponent implements OnInit {
  alert: String;
  constructor(private loginService: LoginService, private router: Router) { }

  ngOnInit() {
    this.alert = JSON.parse(sessionStorage.getItem("alert"));
    this.logout();
  }

  onSubmit(formLogin) {
    this.loginService.sendPost(formLogin.value)
    .then(res => {
      if (res.status === 0){
        this.alert = res.message;
        console.log(this.alert);
      } else {
        this.alert = '';
        sessionStorage.setItem('jwt', JSON.stringify(res.data.accessToken));
        sessionStorage.setItem('currentUser', JSON.stringify(res.data.profile));
        this.router.navigate(['']);
      }
    })
    .catch(err => console.log(err));
  }

  logout() {
    // remove user from local storage to log user out
    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('jwt');
    sessionStorage.removeItem('alert');
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/login/login.component.ts